<template>
  <el-form :inline="true" label-position="top">
    <el-form-item label="關聯商店" v-if="userType==='gaa'" >
      <el-select v-model="shop" clearable filterable remote reserve-keyword placeholder="(搜尋商店，請先選擇儲值帳戶)"
        @change="onShopSelected"
        :remote-method="fetchShops" :loading="select.shops.loading">
        <el-option v-for="option in shops" :key="option.shopId"
          :label="option.shopId + ' ' + option.shopName" :value="option.shopId">
        </el-option>
      </el-select>
    </el-form-item>
  </el-form>
</template>

<script>
import axios from 'axios';

export default {
  name: 'AccountFinder',
  components: [

  ],
  props:  {
    baId: Number,
  },

  mounted() {
    this.fetchShops();
  },

  methods: {
    fetchShops() {
      const merchantId = 'ddcstore';
      if (!this.baId) {
        this.shops = [ ];
        return;
      }
      this.select.shops.loading = true;
      // let apiHost = `https://apis-dev.ddc.ai/vas/v1/merchants/ddcstore/management/billing-accounts/${this.baId}/shops`;
      let apiHost = `${process.env.VUE_APP_APIHOST}/${this.userType}/vas/merchants/ddcstore/billing-accounts/${this.baId}/shops`;

      // let apiHost = `http://localhost:3000/vas/v1/merchants/ddcstore/management/billing-accounts/${this.baId}/shops`;
      axios.get(
        `${apiHost}`
      )
      .then(response => {
        console.log(`[ShopFinder] fetchShops`, response.data);

        if (Array.isArray(response.data)) {
          this.shops = [ ];
          response.data.forEach(shop => {
            this.shops.push({ shopId: shop['shopId'], shopName: shop['shopName'] });
          });
        }
        else {
          throw new Error(`Cannot resolve response data of store list.`);
        }
        
      })
      .catch(err => {
        console.error(`[ShopFinder] Cannot fetch store list`, err);
      })
      .finally(() => {
        this.select.shops.loading = false;
      });
    },

    onShopSelected(id) {
      console.log(`[ShopFinder] on shop selected`, id);
      this.$emit('shop-selected', id, this.selectedShopName);
    }
  },

  data() {
    return {
      shop: null,
      shops: [ ],

      select: {
        shops: {
          loading: false
        }
      }
    };
  },

  computed: {
    selectedShopName() {
      let ret = this.shops.find(shop => {
        return shop.shopId === this.shop;
      });
      if (ret) return ret.shopName;
      return null;
    },

    user() {
      return this.$store.getters.user;
    },
    userType() {
      return this.$store.getters.userType;
    }
  },
  watch: {
    baId: function(id) {
      this.shop = null;
      this.fetchShops();
    }
  }
}
</script>